import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Compute from './views/Compute.vue';
import Dynamic from './views/Dynamic.vue';
import Cache from './views/Cache.vue';
import DataChanel from './views/DataChanel.vue';
import IpDetail from './views/IpDetail.vue';
import CustomerCase from './views/CustomerCase.vue';
import UseDoc from './views/UseDoc.vue';
import Login from './views/Login.vue';
import Admin from './views/Admin.vue';
import SignUp from './views/SignUp.vue';
import CCD from './views/CCD.vue';

Vue.use(Router);
const title = 'BonusCloud: The next generation infrastructure driven by blockchain';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title,
      },
      component: Home,
    },
    {
      path: '/compute',
      name: 'Compute',
      meta: {
        title,
      },
      component: Compute,
    },
    {
      path: '/dynamic',
      name: 'Dynamic',
      meta: {
        title,
      },
      component: Dynamic,
    },
    {
      path: '/cache',
      name: 'Cache',
      meta: {
        title,
      },
      component: Cache,
    },
    {
      path: '/dataChanel',
      name: 'DataChanel',
      meta: {
        title,
      },
      component: DataChanel,
    },
    {
      path: '/ipDetail',
      name: 'IpDetail',
      meta: {
        title,
      },
      component: IpDetail,
    },
    {
      path: '/customerCase',
      name: 'CustomerCase',
      meta: {
        title,
      },
      component: CustomerCase,
    },
    {
      path: '/useDoc',
      name: 'UseDoc',
      meta: {
        title,
      },
      component: UseDoc,
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title,
      },
      component: Login,
    },
    {
      path: '/admin',
      name: 'Admin',
      meta: {
        title,
      },
      component: Admin,
    },
    {
      path: '/signUp',
      name: 'SignUp',
      meta: {
        title,
      },
      component: SignUp,
    },
     {
      path: '/ccd',
      name: 'CCD',
      meta: {
        title,
      },
      component: CCD,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
